import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toZonedTime } from "date-fns-tz";

const TIME_ZONE = "Europe/Zurich";

const DeadlineGuard = ({ children }) => {
    const now = toZonedTime(new Date(), TIME_ZONE);

    // Deadline: April 17, 2025 at 23:55 Zurich time
    const deadline = new Date(2025, 3, 17, 23, 55);
    const zonedDeadline = toZonedTime(deadline, TIME_ZONE);

    const navigate = useNavigate();
    const location = useLocation();

    const pathMatch = location.pathname.match(/^\/(\w{2})\//);
    const language = pathMatch?.[1] || "de";

    const isClosedPath = location.pathname.includes("/closed");

    useEffect(() => {
        if (now > zonedDeadline && !isClosedPath) {
            navigate(`/${language}/closed`, { replace: true });
        }
    }, [now, zonedDeadline, isClosedPath, language, navigate]);

    // While redirecting, don't render anything
    if (now > zonedDeadline && !isClosedPath) return null;

    return children;
};

export default DeadlineGuard;
